import React from 'react';

type Priority = 'High' | 'Medium' | 'Low' | 'Critical';

const priorityConfig: Record<Priority, string> = {
  Critical: 'bg-red-100 text-red-700',
  High: 'bg-red-50 text-red-600',
  Medium: 'bg-amber-50 text-amber-700',
  Low: 'bg-green-50 text-green-700',
};

export default function PriorityBadge({ priority }: { priority: Priority }) {
  const cls = priorityConfig[priority] || 'bg-slate-100 text-slate-600';
  return (
    <span className={`inline-flex items-center rounded text-[11px] font-600 px-1.5 py-0.5 ${cls}`}>
      {priority}
    </span>
  );
}